import { axiosInstance } from "@/lib/axios-instance";
import { IWorkspace } from "@/types/data-models";

interface ToggleResponse {
  status: string;
  result: { raise_board_enabled: boolean; portal_slug: string | null };
}

interface BulkSetResponse {
  status: string;
  matched: number;
  modified: number;
}

interface RaiseBoardApplication {
  _id: string;
  applicant_company:
    | string
    | {
        _id: string;
        company_name?: string;
        short_bio?: string;
        industry?: string[];
        country?: string;
        company_website?: string;
        background_image?: string;
        stage?: number;
        logo_url?: string;
      };
  pertains_to_opportunity: string;
  raise_board?: boolean;
  short_bio?: string;
  industry?: string[];
  deal_info?: Array<{ field_name: string; field_value: unknown; field_state?: string }>;
  attempting_to_raise?: string;
  currency?: string;
  stage?: number;
  business_model?: string | string[];
  revenue_model?: string | string[];
  company_website?: string;
  city?: string;
  country?: string;
  year_of_inception?: string;
  problem?: string;
  solution?: string;
  traction?: string;
  objective?: string;
  linkedIn?: string;
  twitter?: string;
  created_on?: string;
  [key: string]: unknown;
}

export interface RaiseBoardBySlugResponse {
  status: string;
  result: {
    opportunity: IWorkspace;
    applications: RaiseBoardApplication[];
  };
}

export const raiseBoardApi = {
  toggle: async (
    opportunityId: string,
    enabled: boolean
  ): Promise<ToggleResponse> => {
    const response = await axiosInstance.post("/toggle_raise_board", {
      opportunity_id: opportunityId,
      enabled,
    });
    return response.data;
  },

  bulkSet: async (
    opportunityId: string,
    companyIds: string[],
    raiseBoard: boolean
  ): Promise<BulkSetResponse> => {
    const response = await axiosInstance.post("/bulk_set_raise_board", {
      opportunity_id: opportunityId,
      company_ids: companyIds,
      raise_board: raiseBoard,
    });
    return response.data;
  },

  getBySlug: async (slug: string): Promise<RaiseBoardBySlugResponse> => {
    const response = await axiosInstance.get<RaiseBoardBySlugResponse>(
      "/fetch_raise_board_by_slug",
      { params: { slug } }
    );
    return response.data;
  },

  sendDealEmail: async (params: {
    slug: string;
    applicationId: string;
    recipientEmail: string;
    industries?: string;
  }): Promise<{ status: string }> => {
    const response = await axiosInstance.post("/send_raise_board_deal_email", {
      slug: params.slug,
      application_id: params.applicationId,
      recipient_email: params.recipientEmail,
      industries: params.industries,
    });
    // Treat a 2xx-with-error body as a failure so the caller's onSuccess can't
    // fire on a send that didn't happen.
    if (response.data?.status !== "success") {
      throw new Error(response.data?.message || "Failed to send deal details");
    }
    return response.data;
  },
};
